import { render, staticRenderFns } from "./YwDutyRecordFormModal.vue?vue&type=template&id=0867b44c&scoped=true&"
import script from "./YwDutyRecordFormModal.vue?vue&type=script&lang=js&"
export * from "./YwDutyRecordFormModal.vue?vue&type=script&lang=js&"
import style0 from "./YwDutyRecordFormModal.vue?vue&type=style&index=0&id=0867b44c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0867b44c",
  null
  
)

export default component.exports